import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../hooks';
import { useEffect } from 'react';
import { selectTenant } from '../../containers/Organizations/OrganizationsSlice';
import { fetchTenant } from '../../containers/Organizations/OrganizationsSlice/actionCreators';

export function useTenantId() {
  const dispatch = useDispatch();
  const tenant = useAppSelector(selectTenant);

  useEffect(() => {
    const getTenant = async () => {
      await dispatch(fetchTenant());
    };
    if (!tenant) {
      getTenant();
    }
  }, [tenant]);

  return tenant?.id;
}
